import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useUpdateRecruitmentStatusDefinition = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.recruitmentUpdateStatusDefinition,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.recruitmentStatuses]);
    },
  });
};
